'use strict';

const { h, Component } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const Datetime = require('@grpn/preact-l10n/datetime');

const orientationTimeout = require('../../support/orientation-timeout');

class RedemptionTerms extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      toggleActive: props.notExpandable || false,
      contentHeight: 0,
    };

    this.refs = {
      inner: null,
    };

    this.clickHandlerToggle = this.clickHandlerToggle.bind(this);
    this.keyUpHandlerToggle = this.keyUpHandlerToggle.bind(this);
    this.onOrientationChange = this.onOrientationChange.bind(this);
  }

  componentDidMount() {
    this.setContentHeight();

    window.addEventListener('orientationchange', this.onOrientationChange);
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.onOrientationChange);
  }

  render() {
    const { notExpandable } = this.props;
    const { toggleActive } = this.state;

    return h(`.redemption-terms${toggleActive ? '.show' : ''}`, [
      !notExpandable &&
        h(
          '.redemption-terms-label',
          {
            tabindex: 0,
            onClick: this.clickHandlerToggle,
            onKeyUp: this.keyUpHandlerToggle,
          },
          [
            this.getLabelState(),
            h(Translate, 'js.modules.redemption.Terms'),
            this.getIconState(),
          ]
        ),
      h('.redemption-terms-content', { style: this.getInlineStyle() }, [
        h('.redemption-terms-inner', { ref: el => (this.refs.inner = el) }, [
          h(
            Translate,
            { tag: 'h3', attrs: { class: 'redemption-terms-title' } },
            'js.modules.redemption.TermsAndConditions'
          ),
          ...this.getValidityList(),
          this.getTermsList(),
        ]),
      ]),
    ]);
  }

  keyUpHandlerToggle(ev) {
    if (ev.keyCode === 13) {
      this.clickHandlerToggle();
    }
  }

  clickHandlerToggle() {
    const { toggleActive } = this.state;

    this.setState({
      toggleActive: !toggleActive,
    });
  }

  onOrientationChange() {
    const numberOfFramesToWait = 120;

    orientationTimeout(numberOfFramesToWait).then(() =>
      this.setContentHeight()
    );
  }

  setContentHeight() {
    const { inner } = this.refs;

    this.setState({
      contentHeight: inner.offsetHeight,
    });
  }

  getLabelState() {
    const { toggleActive } = this.state;

    const key = !toggleActive ? 'Show' : 'Hide';

    return h(
      Translate,
      {
        attrs: { class: 'redemption-terms-label-text ' },
      },
      `js.modules.redemption.${key}`
    );
  }

  getIconState() {
    const { toggleActive } = this.state;

    let iconClass = '.redemption-terms-icon.icon-arrow-down-large';
    iconClass += toggleActive ? '.redemption-terms-icon-active' : '';

    return h(`span${iconClass}`);
  }

  getInlineStyle() {
    const { notExpandable } = this.props;
    const { toggleActive, contentHeight } = this.state;

    const maxHeight = !!contentHeight && toggleActive ? contentHeight : 0;
    const opacity = !!contentHeight && toggleActive ? 1 : 0;
    const transition = notExpandable ? { transition: 'none' } : {};

    return {
      maxHeight,
      opacity,
      ...transition,
    };
  }

  getValidityList() {
    const { termsAndConditions, expiryDateTime } = this.props;
    const { invalidDays, invalidMonths } = termsAndConditions;

    return [
      h(
        Translate,
        { tag: 'p', attrs: { class: 'redemption-terms-heading' } },
        'js.modules.redemption.NeedToKnow'
      ),
      h('ul.redemption-terms-valid', [
        expiryDateTime &&
          h('li.redemption-terms-valid-item', [
            h('span.redemption-terms-valid-icon.icon-hourglass'),
            h(Translate, 'js.modules.redemption.Ends'),
            ' ',
            h(Datetime, { value: expiryDateTime, format: 'L' }),
          ]),
        !invalidDays &&
          h('li.redemption-terms-valid-item', [
            h('span.redemption-terms-valid-icon.icon-calendar'),
            h(Translate, 'js.modules.offer_availability.ValidOnAllDays'),
          ]),
        !invalidMonths &&
          h('li.redemption-terms-valid-item', [
            h('span.redemption-terms-valid-icon.icon-calendar'),
            h(Translate, 'js.modules.offer_availability.ValidOnAllMonths'),
          ]),
      ]),
    ];
  }

  getTermsList() {
    const {
      termsAndConditions: { terms },
    } = this.props;

    const listItems = terms.split('|');

    return (
      listItems.length > 0 &&
      h(
        'ul.redemption-terms-list',
        listItems.map(item => h('li.redemption-terms-list-item', item))
      )
    );
  }
}

module.exports = RedemptionTerms;
